"use strict";
/**
 * Angular helpers.
 *
 * @packageDocumentation
 * @module AngularHelpers
 * @preferred
 */
Object.defineProperty(exports, "__esModule", { value: true });
//#region Consts
exports.$SCOPE_SERVICE_NAME = '$scope';
exports.$ELEMENT_SERVICE_NAME = '$element';
exports.$SCE_SERVICE_NAME = '$sce';
exports.$TIMEOUT_SERVICE_NAME = '$timeout';
exports.$TRANSCLUDE_SERVICE_NAME = '$transclude';
//#endregion
//# sourceMappingURL=angular.js.map